fn<template>
  <div>
    <v-toolbar flat fixed>
        <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

        <v-toolbar-title class="white--text">Ledger Opening Balance</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn icon @click="fn_new"><v-icon>add</v-icon></v-btn>

        <!-- <v-btn icon @click="fn_getBottomMenu(901)">
          <v-icon>more_vert</v-icon>
        </v-btn> -->

        <v-text-field clearable elevation-10  flat solo placeholder="Search..." v-model.lazy="searchValue" @input="fn_debounceSearch" slot="extension" :class="{'bottom-shadow':scrollPositionTop!=0}"></v-text-field>
    </v-toolbar>

    <div class="hasToolbar hasExtension hasFooter" v-scroll="onScroll">


      <v-list two-line nopadding>

        <v-subheader white-background subheader-ultra-dense>
          Count: {{$root.numberToLocale(listItemObject.totalCount, 1)}}
        </v-subheader>

        <v-divider></v-divider>

        <!-- <div v-if="listItemObject.totalCount">
          <v-divider></v-divider>
            <v-subheader subheader-ultra-dense>Count: {{listItemObject.totalCount}}</v-subheader>
          <v-divider></v-divider>
        </div> -->

        <!-- {{ledgerSummary}} -->

        <div v-for="(item, index) in listItemObject.items" :key="index">
          <v-list-tile class="right-subtitle-tile">
              <v-list-tile-content @click="fn_itemClick(item.transactionId)">
                <v-list-tile-title class="mb-1">{{item.accountLedgerName}}</v-list-tile-title>
                <v-list-tile-sub-title class="mb-1">
                  <span class="right_subtitle">
                    &#8377; {{$root.numberToLocale(item.amount)}}
                    <v-icon font18 :class="[item.amountType!=0 ? 'greencolor' : 'redcolor']">{{item.amountType!=0 ? 'arrow_downward' : 'arrow_upward'}}</v-icon>
                  </span> 
                </v-list-tile-sub-title>
                <v-list-tile-sub-title>{{item.accountGroupName}}</v-list-tile-sub-title>
              </v-list-tile-content>

              <!-- <v-list-tile-action>
                <v-btn icon flat @click="fn_getBottomMenu(902, item.transactionId)"><v-icon>more_horiz</v-icon></v-btn>
              </v-list-tile-action> -->
          </v-list-tile>

          <v-divider v-if="listItemObject.items.length-1 != index"></v-divider>
        </div>


      </v-list>

      <transition name="fade" mode="out-in">
        <v-card noshadow v-if="showPlaceHolder && !listItemObject.totalCount" style="height: calc(100vh - 162px);display: flex;align-items: center;">
          <v-card-text>

            <div center-align>
                    <div @click="fn_new" v-ripple style="width: 68px;height: 68px;border-radius: 50%;background: #F0F0F0;margin: auto;padding: 12px;position:relative">
                      <i aria-hidden="true" class="v-icon material-icons" style="position: absolute;top: 0;right: 0px;background: #4b77be !important;border-radius: 50%;color: #fff !important;font-size: 20px;">add</i>
                      <img src="../../../../assets/icon_wallet.svg" style="opacity:0.6;width:42px" alt="">
                    </div><br>

                    <p class="title light-opacity-color" style="line-height:28px !important">Add Opening Ledger</p>
                  </div>

          </v-card-text>
        </v-card>
      </transition>

      <!-- <div class="display_msg" v-if="!listItemObject.items.length">There are no items</div> -->
    </div>


    <v-footer white-background class="pl-3 pr-3" fixed style="border-top:1px #F0F0F0 solid;height:64px">
      <v-layout wrap align-center style="align-items:baseline">
        <v-flex xs2 sm2 md2 style="text-align:left" v-ripple @click="total_sheet=true">
          <span>Total<v-icon style="position:absolute">keyboard_arrow_up</v-icon></span>
        </v-flex>
        <v-flex xs5 sm5 md5 style="text-align:right">
          To Receive<br>
          <b>&#8377; {{$root.numberToLocale(stockValueAndDebitTotal)}}</b>
        </v-flex>
        <v-flex xs5 sm5 md5 style="text-align:right">
          To Pay<br>
          <b>&#8377; {{$root.numberToLocale(creditTotal)}}</b>
        </v-flex>
      </v-layout>
    </v-footer>

    <v-bottom-sheet v-model="total_sheet">
      <v-list nopadding>

        <v-subheader @click="total_sheet=false" style="height:64px">
          <v-layout wrap align-center style="align-items:baseline">
            <v-flex dark-opacity-color xs2 sm2 md2 style="text-align:left" v-ripple @click="total_sheet=true">
              <span>Total<v-icon style="position:absolute">keyboard_arrow_down</v-icon></span>
            </v-flex>
            <v-flex dark-opacity-color xs5 sm5 md5 style="text-align:right">
              To Receive<br>
              <b>&#8377; {{$root.numberToLocale(stockValueAndDebitTotal)}}</b>
            </v-flex>
            <v-flex dark-opacity-color xs5 sm5 md5 style="text-align:right">
              To Pay<br>
              <b>&#8377; {{$root.numberToLocale(creditTotal)}}</b>
            </v-flex>
          </v-layout>
        </v-subheader>

        <v-divider></v-divider>

        <v-layout wrap align-center style="padding:5px 16px">
          <v-flex xs2 sm2 md2 style="text-align:left" v-ripple>
            <span>Stock Value</span>
          </v-flex>
          <v-flex xs5 sm5 md5 style="text-align:right">
            &#8377; {{$root.numberToLocale(stockSummary.totalAmount)}}
          </v-flex>
          <v-flex xs5 sm5 md5 style="text-align:right"></v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout wrap align-center style="padding:5px 16px">
          <v-flex xs2 sm2 md2 style="text-align:left" v-ripple>
            <span>Ledger Value</span>
          </v-flex>
          <v-flex xs5 sm5 md5 style="text-align:right">
            &#8377; {{$root.numberToLocale(debitTotal)}}
          </v-flex>
          <v-flex xs5 sm5 md5 style="text-align:right">
            &#8377; {{$root.numberToLocale(creditTotal)}}
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout wrap align-center style="padding:5px 16px">
          <v-flex xs2 sm2 md2 style="text-align:left" v-ripple>
            <span>Difference</span>
          </v-flex>
          <v-flex xs5 sm5 md5 style="text-align:right">
            <span v-if="stockValueAndDebitTotal  > creditTotal">&#8377; {{$root.numberToLocale(difference)}}</span>
          </v-flex>
          <v-flex xs5 sm5 md5 style="text-align:right">
            <span v-if="creditTotal  > stockValueAndDebitTotal">&#8377; {{$root.numberToLocale(difference)}}</span>
          </v-flex>
        </v-layout>



        <!-- <v-list-tile>
          <v-list-tile-content><v-list-tile-title>Stock Value</v-list-tile-title></v-list-tile-content>
          <v-list-tile-action>&#8377; {{stockSummary.totalAmount}} Dr</v-list-tile-action>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content><v-list-tile-title>Difference</v-list-tile-title></v-list-tile-content>
          <v-list-tile-action>&#8377; {{difference}} {{creditTotal  > debitTotal ? 'Cr' : 'Dr'}}</v-list-tile-action>
        </v-list-tile> -->
      </v-list>
    </v-bottom-sheet>

    <dialog-drive-alert ref="ref_dialogDriveAlert"></dialog-drive-alert>
  </div>
</template>

<script>
var tagId = null;
const menuItem = require('../../../../config.js').configs.menuItem;
const bottomSheetMenu = require('../../../../config.js').configs.bottomSheetMenu;
const transactionForms = require('../../../../config.js').configs.transactionForms;

import dialogDriveAlert from '../dialogs/dialog_drive_alert'
// import InfiniteLoading from 'vue-infinite-loading';

  export default{
    props:['settings'],
    components: {
        // InfiniteLoading,
        'dialog-drive-alert':dialogDriveAlert
    },
    data(){
      return{
        toolbarTitle:null,
        listItemObject:{"items":[], "totalCount":0},
        searchValue:'',
        infiniteId: +new Date(),
        startIndex:0,
        scrollPositionTop:0,
        selectedItemId:null,
        ledgerSummary: {"items":[]},
        total_sheet:false,
        stockSummary: {totalAmount:0, unitItems:[]},
        loadMore:false,
        showPlaceHolder:false,
        timeoutid:null
      }
    },
    methods:{

      onScroll (event) {
        var element = event.target;
        if (element.documentElement.scrollHeight - element.documentElement.scrollTop - 150 <= element.documentElement.clientHeight)
        {
            console.log('scrolled');
            if(this.listItemObject.items.length < this.listItemObject.totalCount){
              this.fn_loadItems();
            }
        }
      },

      fn_drafts: function(){
        this.$router.push({path:'/drafts', query:{tabIndex:1}});
      },
      fn_initializeSettings: function () {
        transactionForms.filter(item => {
          if(item.id == this.settings.transactionTypeId){
            this.toolbarTitle = item.title;
          }
        })
      },
      fn_goBack: function(){
        this.$router.go(-1);
      },
      fn_menuItemClick: function(tagId, menuId, menuAction){
        // tagId id form future use
        // menuId id form future use
        if(menuAction=='new'){
          // this.fn_new();
        }
        else if(menuAction=='edit'){
          this.$router.push('/transactions/inventory/openingledger/items/'+this.selectedItemId+'/edit');
        }
      },

      // fn_checkDrive: function(){
      //   let self = this;
      //   if(this.$root.CurrentBusiness.DataDrive){
      //     this.fn_new();
      //   }
      //   else{
      //     this.$root.fn_getTransactionCount(function(count){
      //       if(count>=10){
      //         self.$refs['ref_dialogDriveAlert'].dialog_setup_drive = true;
      //       }
      //       else{
      //         self.fn_new();
      //       }
      //     })
      //   }
      // },

      fn_new: function () {
        localStorage.setItem("SetDataDrive", 1);
        this.$router.push({path:'/transactions/inventory/openingledger/items/new', query:{tagId:this.guidWeb()}});
      },

      fn_itemClick: function (itemId) {
        // tagId id form future use
        // itemName id form future use
        this.$router.push('/transactions/inventory/openingledger/items/'+itemId);
      },

      fn_getBottomMenu: function (elementId, itemId) {
        itemId ? this.selectedItemId = itemId : '';

        let bottomMenu;

        // if(elementId == bottomSheetMenu.toolBar.Id){
        //   bottomMenu = {"BottomMenu": [menuItem.help]};
        // }
        if(elementId == bottomSheetMenu.masterListItems.Id){
          bottomMenu = {"BottomMenu": [menuItem.edit]};
        }
        
        this.setBottomMenu(tagId, bottomMenu, 
          {
            onSuccess: function (response) {
              console.log(response);
            },
            onError: function (error) {
              console.log(error);
            }
          }
        )
      },

      // infiniteHandler($state) {
      //   let filterObject = {};
      //   filterObject.type = this.settings.transactionTypeId;
      //   filterObject.limit = 10;
      //   filterObject.startIndex = this.startIndex;
      //   filterObject.search = this.searchValue.toLowerCase();

      //   let self = this;
      //   this.getItems("OpeningLedgerList", filterObject, 
      //     {
      //       onSuccess: function (response) {
      //         console.log(response);
      //         let responseJson = JSON.parse(response);
      //         self.listItemObject.totalCount = responseJson.totalCount;
      //         self.fn_getSummary(filterObject);

      //         for(let i in responseJson.items){
      //           self.listItemObject.items.push(responseJson.items[i]);  
      //         }

      //         self.startIndex = self.listItemObject.items.length;

      //         if(self.listItemObject.items.length < self.listItemObject.totalCount){
      //           $state.loaded();
      //         }
      //         else{
      //           $state.complete();
      //         }
      //       },
      //       onError: function (error) {
      //         console.log(error);
      //       }
      //     }
      //   )
      // },


     // fn_searchItem: function () {
     //    this.startIndex = 0;
     //    this.infiniteId += 1;
     //    this.listItemObject.items = [];
     //    // this.fn_getItems(searchValue, 0);
     //  },

     fn_debounceSearch: function(){
          if (this.timeoutid != null){
            clearTimeout(this.timeoutid);
          }

        this.timeoutid = setTimeout(() => { 
            this.fn_searchItem();
        },100);
    },

     fn_loadItems(search) {
        let filterObject = {};
        filterObject.type = this.settings.transactionTypeId;
        filterObject.limit = 50;
        filterObject.startIndex = this.startIndex;
        filterObject.search = this.searchValue ? this.searchValue.toLowerCase() : '';

        let self = this;
        this.getItems("OpeningLedgerList", filterObject, 
          {
            onSuccess: function (response) {
              console.log(response);
              let responseJson = JSON.parse(response);
              self.listItemObject.totalCount = responseJson.totalCount;
              self.fn_getSummary(filterObject);

              search ? self.listItemObject.items = [] : '';
              for(let i in responseJson.items){
                self.listItemObject.items.push(responseJson.items[i]);
              }

              self.startIndex = self.listItemObject.items.length;
              self.loadMore = false;

              setTimeout(function(){
                self.showPlaceHolder = true;
              },300);
            },
            onError: function (error) {
              console.log(error);
              self.loadMore = false;
            }
          }
        )
      },

     fn_searchItem: function () {
        this.startIndex = 0;
        this.listItemObject.items = [];
        this.fn_loadItems(true);
      },

      fn_getSummary: function (filterObject) {
        let self = this;
        this.getItems('LedgerSummaryList', filterObject, 
        {
          onSuccess: function (response) {
            console.log(response);
            self.ledgerSummary = JSON.parse(response);
            self.fn_getStockSummary();
          },
          onError: function (error) {
            console.log(error);
          }
        })
      },

      fn_getStockSummary: function () {
        var self = this;
        let filterObject = {};
        filterObject.type = 40001;
        filterObject.search = '';
        this.getItems('OpeningStockSummaryList', filterObject,
        {
            onSuccess: function(response){
              self.stockSummary = JSON.parse(response);
              self.stockSummary.totalAmount = self.roundUpto2Decimals(self.stockSummary.totalAmount);
              console.log(response);
            }, 
            onError: function(error){
              console.log(error);
            }
        });
      },

      fn_showWebView: function () {
        let viewObject = {};
        let self = this;

        this.showWebView(tagId, viewObject, 
          {
            onSuccess: function(response){
                  console.log(response);
                }, 
                onError: function(error){
                  console.log(error);
                }, 
                // onChange: null, 
                onMenuItemClick: function (tagId, menuId, menuAction) {
              self.fn_menuItemClick(tagId, menuId, menuAction)
            }
          }
        );
      },
    },
    mounted: function(){
      tagId = this.$route.query.tagId;

      this.fn_initializeSettings();

      this.fn_showWebView();
      window.js_globals.fn_onBackPress = this.fn_goBack;

      let self = this;
      document.addEventListener('scroll', function () {
        self.scrollPositionTop = window.pageYOffset
      })

      this.fn_loadItems();

      //, this.fn_getItems(this.searchValue, 0);
    },
    beforeRouteLeave (to, from, next) {
        if(this.total_sheet){
          this.total_sheet = false;
          next(false);
        }
        else {
          next();
        }
    },
    computed:{
      debitTotal: function () {
        let total = 0;
        this.ledgerSummary.items.forEach(function (item) {
          item.amountType == 1 ? total += item.total : '';
        });
        return this.roundUpto2Decimals(total);
      },
      stockValueAndDebitTotal: function(){
        return this.roundUpto2Decimals(this.debitTotal+this.stockSummary.totalAmount);
      },
      creditTotal: function () {
        let total = 0;
        this.ledgerSummary.items.forEach(function (item) {
          item.amountType == 0 ? total += item.total : '';
        });
        return this.roundUpto2Decimals(total);
      },
      difference: function () {
        let diff = this.creditTotal - this.stockValueAndDebitTotal;
        if(diff < 0)
          return this.roundUpto2Decimals(-diff);
        else 
          return this.roundUpto2Decimals(diff);
      }
    }
  };
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/opening_ledger/items.vue